const updates = [
  { date: '08-01', title: '《繁花》沪语版全集上线，原汁原味上海故事', tag: '新剧上线' },
  { date: '07-31', title: '《流浪地球3》4K修复版独家上线，震撼视听体验', tag: '高清上线' },
  { date: '07-30', title: '暑期档片单更新：30部高分新片限时免费看', tag: '限免' },
  { date: '07-29', title: '综艺频道改版升级，新增弹幕互动功能', tag: '功能更新' },
  { date: '07-28', title: '《庆余年2》播放量突破5亿，续写权谋传奇', tag: '热播' },
  { date: '07-27', title: '动漫专区上线，收录1000+部热门番剧', tag: '新专区' },
  { date: '07-26', title: '播放器升级：支持4K超清与杜比音效', tag: '技术升级' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">最新动态</h2>
          <p className="text-sm text-foreground-500">每日更新 · 影视资讯一手掌握</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-14 md:w-16 text-center">
                <div className="text-xs text-foreground-400 font-medium">{item.date}</div>
                <div className="mt-1 w-2 h-2 rounded-full bg-primary-500 mx-auto group-hover:scale-125 transition-transform"></div>
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                  {item.title}
                </p>
              </div>
              <span className="flex-shrink-0 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}